<template>
  <div style="font-size:14px">
    <div class="bg-kplh-primary text-white">
      FORMULIR PRAKUALIFIKASI SISTEM MANAJEMEN KESELAMATAN PERTAMBANGAN DAN
      LINGKUNGAN HIDUP (KRITERIA RISIKO
      {{
        kplh &&
          convertFromSkalaBesar(
            $get(kplh, 'request.kplh_penilaian.tingkat_resiko', '-')
          )
      }})
    </div>
    <div class="mb10">
      No. formulir: FRM-014-001-{{
        kplh && $get(kplh, 'request.kplh_penilaian.tingkat_resiko', '-')[0]
      }}
    </div>
    <div class="flex flex-row mb10">
      <table class="col-7 text-sm">
        <tr class="bg-kplh-second text-white" style="height: 20px">
          PETUNJUK PENGISIAN BAGI CALON VENDOR / KONTRAKTOR
        </tr>
        <tr>
          1. Formulir ini terdiri dari 13
          <strong>Persyaratan</strong>
          (A s/d M) dan setiap Persyaratan memiliki
          <strong>Bobot</strong>
          tersendiri.
        </tr>
        <tr>
          2. Calon Vendor / Kontraktor melampirkan salinan dokumen yang diminta
          dalam setiap persyaratan.
        </tr>
        <tr>
          3. Salinan dokumen dilampirkan terpisah pada Dokumen Lampiran.
          <strong>Dokumen Lampiran</strong>
          harus memuat
          <strong>Daftar Isi Lampiran</strong>
          beserta penomoran pada setiap Lampiran untuk memudahkan pelacakan saat
          dilakukan penilaian.
        </tr>
        <tr>
          4. Kolom Nilai dan kolom Penjelasan Hasil Penilaian diisi oleh Tim
          Penilai GEMS.
        </tr>
      </table>

      <table class="col-5 text-sm">
        <tr class="bg-kplh-second text-white" style="height: 20px">
          PETUNJUK PENGISIAN BAGI TIM PENILAI
        </tr>
        <tr>
          0: Tidak ada / tidak tersedia / tidak dijelaskan
        </tr>
        <tr>
          1: Persyaratan belum terpenuhi
        </tr>
        <tr>
          2: Persyaratan cukup memadai tetapi perlu perbaikan
        </tr>
        <tr>
          3: Persyaratan sudah memadai
        </tr>
      </table>
    </div>
    <div class="mb10">
      <table class="w-100">
        <tr>
          <td colspan="3" class="bg-kplh-second text-white">
            Informasi Perusahaan
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">1</td>
          <td class="col-6 bg-kplh-third">Nama Perusahaan</td>
          <td class="col-5">{{ kplh && $get(kplh, 'nama_vendor') }}</td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">2</td>
          <td class="col-6 bg-kplh-third">Alamat Perusahaan</td>
          <td class="col-5">
            {{ kplh && $get(kplh, 'request.vendor.alamat') }}
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">3</td>
          <td class="col-6 bg-kplh-third">Jenis Badan Usaha</td>
          <td class="col-5">
            {{ kplh ? $get(kplh, 'request.vendor.badan_usaha.desc') : '' }}
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">4</td>
          <td class="col-6 bg-kplh-third">Bidang Usaha / Jenis Pekerjaan</td>
          <td class="col-5">
            <!-- {{ bidang_usaha_gems && bidang_usaha_gems.join(',') }} -->
            <div v-if="bidang_usaha_gems && bidang_usaha_gems.length > 0">
              <p
                v-for="(list, index) in bidang_usaha_gems"
                :key="index"
                style="list-style-type: decimal; border-bottom: none"
              >
                {{ index + 1 }}. {{ list }}
              </p>
            </div>
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">5</td>
          <td class="col-6 bg-kplh-third">
            Penanggung Jawab Operasional (PJO) / Person In Charge (PIC)
          </td>
          <td class="col-5">
            {{ kplh && $get(kplh, 'request.kplh_request.pic_name') }}
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">6</td>
          <td class="col-6 bg-kplh-third">
            Posisi PJO / PIC dalam Struktur Organisasi Perusahaan
          </td>
          <td class="col-5">
            {{ kplh && $get(kplh, 'request.kplh_request.pic_position') }}
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">7</td>
          <td class="col-6 bg-kplh-third">Email PJO / PIC</td>
          <td class="col-5">
            {{ kplh && $get(kplh, 'request.kplh_request.pic_email') }}
          </td>
        </tr>
        <tr>
          <td class="col-1 bg-kplh-third">8</td>
          <td class="col-6 bg-kplh-third">Nomor Kontak PJO / PIC</td>
          <td class="col-5">
            {{ kplh && $get(kplh, 'request.kplh_request.pic_phone') }}
          </td>
        </tr>
      </table>
    </div>
    <kplh-template-kritis
      v-if="
        kplh &&
          $get(
            kplh,
            'request.kplh_penilaian.tingkat_resiko',
            '-'
          ).toUpperCase() == '-'
      "
      :kplh="kplh"
      :finalResult="finalResult"
      :totalResult="totalResult"
      :penilaian="penilaian"
      :bobot="bobot"
      :totalNilai="totalNilai"
    />
    <kplh-template-kritis
      v-if="
        kplh &&
          $get(
            kplh,
            'request.kplh_penilaian.tingkat_resiko',
            '-'
          ).toUpperCase() == 'KRITIS'
      "
      :kplh="kplh"
      :finalResult="finalResult"
      :totalResult="totalResult"
      :penilaian="penilaian"
      :bobot="bobot"
      :totalNilai="totalNilai"
    />
    <kplh-template-tinggi
      v-if="
        kplh &&
          $get(
            kplh,
            'request.kplh_penilaian.tingkat_resiko',
            '-'
          ).toUpperCase() == 'TINGGI'
      "
      :kplh="kplh"
      :finalResult="finalResult"
      :totalResult="totalResult"
      :penilaian="penilaian"
      :bobot="bobot"
      :totalNilai="totalNilai"
    />
    <kplh-template-sedang
      v-if="
        kplh &&
          $get(
            kplh,
            'request.kplh_penilaian.tingkat_resiko',
            '-'
          ).toUpperCase() == 'SEDANG'
      "
      :kplh="kplh"
      :finalResult="finalResult"
      :totalResult="totalResult"
      :penilaian="penilaian"
      :bobot="bobot"
      :totalNilai="totalNilai"
    />
    <kplh-template-rendah
      v-if="
        kplh &&
          $get(
            kplh,
            'request.kplh_penilaian.tingkat_resiko',
            '-'
          ).toUpperCase() == 'RENDAH'
      "
      :kplh="kplh"
      :finalResult="finalResult"
      :totalResult="totalResult"
      :penilaian="penilaian"
      :bobot="bobot"
      :totalNilai="totalNilai"
    />
    <div class="flex flex-row">
      <div class="w-50 h-auto flex-center">
        <img :src="newQRCode" alt="QRCode" />
      </div>
      <kplh-approver :kplh="kplh" />
    </div>
  </div>
</template>
<script>
import VueJwtDecode from 'vue-jwt-decode'
import axios from 'axios'
import moment from 'moment'
import { api, api_lp } from '@/services/config'
import QRious from 'qrious'
export default {
  components: {
    kplhApprover: () => import('./kplh-approver.vue'),
    kplhTemplateKritis: () => import('./kplh-template-kritis.vue'),
    kplhTemplateTinggi: () => import('./kplh-template-tinggi.vue'),
    kplhTemplateSedang: () => import('./kplh-template-sedang.vue'),
    kplhTemplateRendah: () => import('./kplh-template-rendah.vue'),
  },
  data() {
    return {
      kplh: null,
      penilaian: null,
      kbli: [],
      qrcode: new QRious({ size: 300 }),
      bidang_usaha_gems: '',
      tableResiko: {
        kritis: 159,
        tinggi: 122,
        sedang: 41,
        rendah: 10,
      },
    }
  },
  async created() {
    // this.getFullRequest(this.$route.params.id)
    const token = await this.$route.params.token
    const dec = await VueJwtDecode.decode(token)
    const { id } = dec
    await this.getFullRequest(id)
  },
  computed: {
    totalResult() {
      const total =
        this.kplh &&
        this.$get(this.kplh, 'request.kplh_penilaian.total_result', 0)
      if (total) {
        return Number(total).toFixed(2)
      }

      return 0
    },
    finalResult() {
      const result =
        this.kplh &&
        this.$get(this.kplh, 'request.kplh_penilaian.final_result', '-')

      console.log('finalResult: ', result)
      return result
    },
    newQRCode() {
      this.qrcode.value = `${process.env.VUE_APP_ISUPPLIER_LANDING_URL}pdf/kplh-vendor/${this.$route.params.token}`
      return this.qrcode.toDataURL()
    },
    bobot() {
      let bobot = 0
      const tingkatResiko =
        this.kplh &&
        this.$get(
          this.kplh,
          'request.kplh_penilaian.tingkat_resiko',
          '-'
        ).toLowerCase()
      if (tingkatResiko.toLowerCase() == 'kritis')
        bobot = this.tableResiko[tingkatResiko]
      if (tingkatResiko.toLowerCase() == 'tinggi')
        bobot = this.tableResiko[tingkatResiko]
      if (tingkatResiko.toLowerCase() == 'sedang')
        bobot = this.tableResiko[tingkatResiko]
      if (tingkatResiko.toLowerCase() == 'rendah')
        bobot = this.tableResiko[tingkatResiko]

      console.log('bobot by tingkat resiko: ', tingkatResiko)
      console.log('table tingkat resiko: ', this.tableResiko)

      return bobot
    },
    totalNilai() {
      let total = 0
      if (this.totalResult && this.totalResult != 0) {
        total = (Number(this.totalResult) * Number(this.bobot)) / 100
      }

      return total.toFixed(2)
    },
  },
  methods: {
    async getFullRequest(id) {
      try {
        this.$store.commit('SET_GLOBAL_LOADING', true)
        console.log('get full request id: ', id)
        const { data } = await axios({
          method: 'GET',
          url: `${api}/api/v1/request/full-request-kplh/${id}`,
        })

        if (data && data.status == 'success') {
          const result = data.data
          this.kplh = result

          console.log('result: ', result)

          let bidang_usaha_gems = this.$get(
            result,
            'request.kplh_request.bidang_usaha_gems',
            '[]'
          )

          if (
            bidang_usaha_gems &&
            bidang_usaha_gems != '[]' &&
            bidang_usaha_gems != 'null'
          ) {
            this.bidang_usaha_gems = JSON.parse(bidang_usaha_gems).map(
              item => item.JENPEK
            )
          }

          let note_1 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_ah',
            {}
          )

          let note_2 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_i1',
            {}
          )
          let note_3 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_i2',
            {}
          )
          let note_4 = this.$get(
            result,
            'request.kplh_penilaian.kplh_note_jm',
            {}
          )

          let value_1 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_ah',
            {}
          )
          let value_2 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_i1',
            {}
          )
          let value_3 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_i2',
            {}
          )
          let value_4 = this.$get(
            result,
            'request.kplh_penilaian.kplh_value_jm',
            {}
          )

          this.penilaian = {
            ...this.kplh,
            ...JSON.parse(note_1),
            ...JSON.parse(note_2),
            ...JSON.parse(note_3),
            ...JSON.parse(note_4),
            ...JSON.parse(value_1),
            ...JSON.parse(value_2),
            ...JSON.parse(value_3),
            ...JSON.parse(value_4),
          }

          if (result.request.vendor.kbli.length > 0) {
            this.kbli = result.request.vendor.kbli.map(
              item => item.kbli_sub.desc
            )
            console.log('KBLI: ', this.kbli)
          }
          console.log('kplh: ', this.kplh)
          await this.$store.commit('SET_GLOBAL_LOADING', false)
        }
      } catch (error) {
        console.log(
          '🚀 ~ file: ValidationK3L.vue ~ line 263 ~ getFullRequest ~ error',
          error
        )
        this.$store.commit('SET_GLOBAL_LOADING', false)
      }
    },
  },
}
</script>
